import {Timestamp} from "@angular/fire/firestore";

export class SiteMessage {
  documentId:string;
  id:string;
  message:string;
  title:string;
  dateAdded:Timestamp|null;
  dateRemoved:Timestamp|null;
  addedBy:string;
  siteName:string;
  address:string;
  englishTitle:string;
  englishMessage:string;
  swedishTitle:string;
  swedishMessage:string;
  norwegianTitle:string;
  norwegianMessage:string;
  germanTitle:string;
  germanMessage:string;


  constructor(id: string, message: string, title:string, dateAdded:Timestamp,dateRemoved:Timestamp, addedBy:string, siteName:string, address:string, swedishTitle:string,swedishMessage:string,norwegianTitle:string,norwegianMessage:string,germanTitle:string,germanMessage:string,englishTitle:string,englishMessage:string) {
    this.id = id;
    this.message = message;
    this.title = title;
    this.dateAdded = dateAdded;
    this.dateRemoved = dateRemoved;
    this.addedBy = addedBy;
    this.siteName = siteName;
    this.address = address;
    this.englishTitle = englishTitle;
    this.englishMessage = englishMessage;
    this.swedishTitle = swedishTitle;
    this.swedishMessage = swedishMessage;
    this.norwegianTitle = norwegianTitle;
    this.norwegianMessage = norwegianMessage;
    this.germanTitle = germanTitle;
    this.germanMessage = germanMessage;

  }
}
